import gql from 'graphql-tag';
const RESENT_TEMPORARY_PASSWORD = gql`
  mutation resendTempPasswordDashboardUser($username: String!) {
    resendTempPasswordDashboardUser(username: $username)
  }
`;

export default RESENT_TEMPORARY_PASSWORD;
